import { API_BASE } from '../../constants';
import { makeHttpGet } from '../';
import { ComparisonFundQuotesUseCase } from '../../usecases';
import {
  createComparisonDrawDownSerie,
  createComparisonNetWorthSerie,
  createComparisonQuotaHolderSerie,
  createComparisonVolatilitySerie,
  createProfitSeries,
} from '../../helpers';
import {
  IFundQuotes,
  IGetAssetColorRepo,
  IGetAssetMemory,
  ISetAssetMemory,
  IAssetQuotes,
} from '../../interfaces';

export const makeComparisonFundQuotes = (
  fundColorRepo: IGetAssetColorRepo,
  fundMemoryRepo: IGetAssetMemory<IFundQuotes> & ISetAssetMemory<IFundQuotes>
) => {
  const url = `${API_BASE}/funds/quotes`;
  const httpGet = makeHttpGet<IAssetQuotes>();

  return new ComparisonFundQuotesUseCase(
    url,
    httpGet,
    createComparisonNetWorthSerie,
    createComparisonQuotaHolderSerie,
    createComparisonDrawDownSerie,
    createComparisonVolatilitySerie,
    createProfitSeries,
    fundColorRepo,
    fundMemoryRepo
  );
};
